// useNetworkStatus.ts
import { useEffect, useState } from 'react';
import { Network } from '@capacitor/network';

export function useNetworkStatus() {
	const [isOnline, setIsOnline] = useState(true);

	useEffect(() => {
		// Check initial status
		const checkStatus = async () => {
			const status = await Network.getStatus();
			setIsOnline(status.connected);
		};

		checkStatus();

		// Listen to network changes
		const handler = Network.addListener('networkStatusChange', (status) => {
			setIsOnline(status.connected);
		});

		return () => {
			handler.then((h) => h.remove());
		};
	}, []);

	return isOnline;
}
